import { MessageCircle } from "lucide-react";
import { useSettings, buildWhatsAppLink } from "@/context/SettingsContext";

export default function FloatingWhatsApp() {
  const { settings } = useSettings();
  return (
    <a
      href={buildWhatsAppLink(settings)}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-5 right-5 z-40 w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] hover:bg-[#1DA851] border-2 border-[#D4AF37] text-white flex items-center justify-center shadow-[0_0_28px_rgba(37,211,102,0.35)] hover:scale-110 transition-transform"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp-button"
    >
      <MessageCircle className="w-6 h-6 md:w-7 md:h-7" />
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-[#D4AF37] rounded-full animate-pulse" />
    </a>
  );
}
